import { jsx as _jsx } from "react/jsx-runtime";
import PhraseContext from './PhraseContext';
const PhraseProvider = ({ phrases = {}, children }) => {
    const phrase = (key, defaultPhrase) => { var _a; return (_a = phrases[key]) !== null && _a !== void 0 ? _a : defaultPhrase; };
    return (_jsx(PhraseContext.Provider, Object.assign({ value: { phrase } }, { children: children })));
};
export default PhraseProvider;
